export enum AtomAttentionBadgeTypeEnum {
  WARN = "warning",
  DANGER = "danger",
  SUCCESS = "success",
}
